/**
 * src/shell/identity/category-icons.tsx
 *
 * Dedicated icon resolver for identity and expertise categories.
 * Separated from UserAvatar to preserve Vite Fast Refresh HMR compatibility.
 */

import React from 'react';
import {
  CodeIcon,
  DollarIcon,
  PaletteIcon,
  BriefcaseIcon,
  SparklesIcon,
  ShieldIcon,
  CpuIcon,
  UsersIcon,
} from '../icons.js';

export function getCategoryVectorIcon(categoryId: string, size = 14, color?: string): React.ReactNode {
  switch (categoryId) {
    case 'engineering':
      return <CodeIcon size={size} color={color} />;
    case 'finance':
      return <DollarIcon size={size} color={color} />;
    case 'design':
      return <PaletteIcon size={size} color={color} />;
    case 'operations':
      return <BriefcaseIcon size={size} color={color} />;
    case 'security':
      return <ShieldIcon size={size} color={color} />;
    case 'ai-ml':
      return <CpuIcon size={size} color={color} />;
    case 'community':
      return <UsersIcon size={size} color={color} />;
    default:
      return <SparklesIcon size={size} color={color} />;
  }
}
